import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=0ef4fb04&scoped=true&"
import script from "./NavigationBar.vue?vue&type=script&lang=js&"
export * from "./NavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=0ef4fb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef4fb04",
  null
  
)

export default component.exports